import { cx } from '@linaria/core';
import { PublisherLogo, colors } from '@ui/kit';
import { usePlatformIOS, usePlatformSafari } from '@utils/common';
import { wrapper, backgroundIcon, table, content } from './_print-template.style.js';
import { PrintFooter } from './atom.footer.js';
import { PrintHeader } from './atom.header.js';
import { ExportServiceFontFixer } from './util.export-service-font-fixer.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ComponentFrameworkPrintTemplate(props) {
  const isIOS = usePlatformIOS();
  const isSafari = usePlatformSafari();
  return /*#__PURE__*/jsxs("div", {
    "aria-hidden": true,
    "data-disable-polly": true,
    "data-print-target": true,
    children: [/*#__PURE__*/jsx(ExportServiceFontFixer, {}), /*#__PURE__*/jsxs("div", {
      "data-print-wrapper": true,
      className: wrapper,
      children: [/*#__PURE__*/jsx(PrintHeader, {
        position: "fixed"
      }), !isIOS && !isSafari && /*#__PURE__*/jsx(PublisherLogo, {
        small: true,
        color: colors.gray.sim03(),
        className: backgroundIcon
      }), /*#__PURE__*/jsxs("table", {
        className: table,
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsx("tr", {
            children: /*#__PURE__*/jsx("td", {
              children: /*#__PURE__*/jsx(PrintHeader, {
                position: "table"
              })
            })
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: /*#__PURE__*/jsx("tr", {
            children: /*#__PURE__*/jsx("td", {
              children: /*#__PURE__*/jsx("main", {
                className: cx(content, "print-content"),
                "data-word-target": true,
                children: props.children
              })
            })
          })
        }), /*#__PURE__*/jsx("tfoot", {
          children: /*#__PURE__*/jsx("tr", {
            children: /*#__PURE__*/jsx("td", {
              children: /*#__PURE__*/jsx(PrintFooter, {
                position: "table"
              })
            })
          })
        })]
      }), !isIOS && !isSafari && /*#__PURE__*/jsx(PrintFooter, {
        position: "fixed"
      })]
    })]
  });
}

export { ComponentFrameworkPrintTemplate };
//# sourceMappingURL=_print-template.js.map
